import React from "react";
import {
  AppBar,
  Backdrop,
  Box,
  Modal,
  Paper,
  Slide,
  Stack,
  Toolbar,
  Typography,
  useTheme,
} from "@mui/material";
import { WaveBG } from "../TitleAnimation/WaveBG";
import { EGIconButton } from "../../MainComponents/Button/IconButton/IconButton";
import { BoldAI } from "../../Icon";

export const BackdropAI = ({
  open,
  onClose,
  title = "",
  onExited = () => {},
  children,
}) => {
  const theme = useTheme();

  // Base colors for the wave background
  const primaryMain = theme.palette.primary.main;
  const primaryDark = theme.palette.primary.dark;
  const contrastText = theme.palette.getContrastText(primaryMain);
  const whiteBase = { r: 255, g: 255, b: 255 };

  return (
    <Modal
      open={open}
      onClose={onClose}
      keepMounted
      disableAutoFocus
      disableEnforceFocus
    >
      <>
        <Backdrop
          open
          sx={{
            zIndex: (th) => th.zIndex.modal + 1,
            backdropFilter: "blur(2px)",
          }}
        />
        <Slide
          direction="left"
          in={open}
          mountOnEnter
          unmountOnExit
          onExited={onExited}
        >
          <Paper
            elevation={6}
            sx={{
              position: "fixed",
              top: 0,
              right: 0,
              height: `100%`,
              width: { xs: "100%", md: "65%", lg: "55%" },
              bgcolor: "background.paper",
              zIndex: theme.zIndex.modal + 3,
              overflowY: "auto",
              borderTopLeftRadius: 16,
              borderBottomLeftRadius: 16,
            }}
          >
            {/* NavBar */}
            <AppBar
              position="sticky"
              elevation={0}
              sx={{ background: "transparent" }}
            >
              <Toolbar
                className="toolbar-with-waves"
                sx={{
                  background: `linear-gradient(180deg, ${primaryMain} 0%, ${primaryDark} 100%)`,
                  color: contrastText,
                  position: "relative",
                  overflow: "visible",
                }}
              >
                <Stack
                  sx={{
                    width: "100%",
                    alignItems: "center",
                    justifyContent: "space-between",
                    flexFlow: "row nowrap",
                  }}
                >
                  <Typography
                    px={1}
                    textAlign="center"
                    fontSize={18}
                    fontWeight={700}
                  >
                    <BoldAI
                      color={theme.palette.common.white}
                      style={{ marginRight: "15px" }}
                    />
                    {title}
                  </Typography>
                  <EGIconButton
                    iconName="close_icon"
                    iconColor="white"
                    iconSize={30}
                    onClick={onClose}
                  />
                </Stack>
                <WaveBG
                  waveCount={6}
                  points={64}
                  whiteBase={whiteBase}
                  height={"100%"}
                />
              </Toolbar>
            </AppBar>
            <Box>{children}</Box>
          </Paper>
        </Slide>
      </>
    </Modal>
  );
};
